var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { withFormsy } from 'formsy-react';
import { FaEyeSlash as EyeSlashIcon, FaEye as EyeIcon } from 'react-icons/fa';
import FormGroup from '../FormGroup';
import Tooltip, { TooltipWrapper } from '../Tooltip';
import { InputIcon, Input as StyledInput } from './style';
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            revealPassword: false
        };
        _this.componentDidMount = function () {
            if (_this.props.value) {
                _this.props.setValue(_this.props.value);
            }
            if (_this.props.style) {
                console.error('The "style" prop may be deprecated in the future, please use the styled-component "css" prop instead. (More info at: https://styled-components.com/docs/api#css-prop)');
            }
        };
        _this.onChange = function (event) {
            if (!_this.props.isValid()) {
                _this.props.setValue(event.currentTarget.value);
            }
            else {
                _this.props.setValue(event.currentTarget.value, false);
            }
            if (_this.props.input.onChange) {
                _this.props.input.onChange(event, _this.props.getValue());
            }
        };
        _this.onBlur = function (event) {
            _this.props.setValue(_this.props.getValue() && _this.props.getValue().trim());
            if (_this.props.input.onBlur) {
                _this.props.input.onBlur(event);
            }
        };
        _this.togglePasswordReveal = function () {
            return _this.setState({ revealPassword: !_this.state.revealPassword });
        };
        return _this;
    }
    Input.prototype.render = function () {
        var errorMessage = this.props.getErrorMessage();
        var _a = this.props.input, type = _a.type, inputProps = __rest(_a, ["type"]);
        var input = (_jsx(StyledInput, __assign({ as: this.props.input.type === 'textarea' ? 'textarea' : 'input' }, inputProps, { ref: this.props.input.ref, type: this.props.input.type === 'password' && this.state.revealPassword
                ? 'text'
                : this.props.input.type, color: this.props.input.color, onChange: this.onChange, onBlur: this.onBlur, value: this.props.getValue() || '', name: this.props.name, isInvalid: errorMessage !== null ||
                (this.props.showRequired() && !this.props.isPristine()) })));
        var formFeedback = errorMessage ? (_jsx(Tooltip, __assign({ color: "red", "data-test-id": this.props.errorFeedbackTestId, style: this.props.errorFeedbackStyle }, { children: errorMessage }))) : null;
        var formRequiredFeedback = this.props.showRequired() && !this.props.isPristine() ? (_jsx(Tooltip, __assign({ color: "red", "data-test-id": this.props.requiredFeedbackTestId, style: this.props.errorFeedbackStyle }, { children: "This field is required" }))) : null;
        var inputTooltip = this.props.tooltip ? (Array.isArray(this.props.tooltip) ? (_jsx(TooltipWrapper, { children: this.props.tooltip.map(function (t, i) { return (_jsx(Tooltip, { children: t }, i)); }) })) : (_jsx(TooltipWrapper, { children: _jsx(Tooltip, { children: this.props.tooltip }) }))) : null;
        return (_jsxs(FormGroup, __assign({ inputType: this.props.input.type, hasTooltip: !!inputTooltip, style: this.props.style, css: this.props.css }, { children: [this.props.input.type === 'password' && (_jsx(InputIcon, { as: this.state.revealPassword ? EyeSlashIcon : EyeIcon, onClick: this.togglePasswordReveal })), this.props.customIcon && (_jsx(InputIcon, __assign({ as: this.props.customIcon.icon }, this.props.customIcon.props))), input, formFeedback, formRequiredFeedback, inputTooltip] })));
    };
    return Input;
}(React.Component));
export default withFormsy(Input);
export { StyledInput, InputIcon };
//# sourceMappingURL=index.js.map